import React from 'react';
import ReactDOM from 'react-dom';

import { MenuContent } from '@menu/components';

const Menu = {
  start: function(params) {
    ReactDOM.render(
      <MenuContent 
        menuContent={ params.menuContent }
        mobile={ params.mobile }
      />, document.getElementById(params.id))
  }
};

window.Menu = Menu;
